import { render, staticRenderFns } from "./FormOptionPage.vue?vue&type=template&id=3532836e&"
import script from "./FormOptionPage.vue?vue&type=script&lang=js&"
export * from "./FormOptionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports